import { AssetType, PayoutType } from "./AdminClasses"

var getPayoutTypeLocale = (type_id: PayoutType)=>{
	switch(type_id){
		case PayoutType.NORMAL: return 'Liquidación';
		case PayoutType.ADELANTO: return 'Anticipo';
		case PayoutType.RETORNO: return 'Retorno';
		default: return 'Otro';
	}
}

const TERMINAL_TYPES = [
	// { id: 1, name: 'AREMA Pinpad', },
	{ id: 2, name: 'Getnet API' },
]

function getHashSpecial(order_id: number, payment_id: number, refund_id: number=null){
	var special = 0, num = order_id+payment_id*3;
	if(refund_id){
		num += refund_id * 13;
	}
	while(num>0) {
		var d = num % 10;
		special += d * ((d%3==0) ? 3 : 1);
		num = Math.floor(num / 10);
	}
	return special;
}

function hashPaymentOrder(order_id: number, payment_id: number, refund_id: number=null){
	var special = getHashSpecial(order_id, payment_id, refund_id);
	var refund_part = '';
	if(refund_id){
		refund_part = `_${refund_id.toString(30)}`
	}
	return `A${order_id.toString(31)}_${payment_id.toString(32)}${refund_part}-${special%100}`.toUpperCase();
}

function dehashPaymentOrder(hash: string){
	var reg = /A(?<o>[0-9a-z]+)_(?<p>[0-9a-z]+)(?:_(?<r>[0-9a-z]))?-(?<s>[0-9]+)/gi;
	var reg_res = reg.exec(hash);
	if(!reg_res || !reg_res.groups.o || !reg_res.groups.p || !reg_res.groups.s) return null;
	
	var order_id = parseInt(reg_res.groups.o, 31);
	var payment_id = parseInt(reg_res.groups.p, 32);
	var refund_id = null;
	if(!!reg_res.groups.r){
		refund_id = parseInt(reg_res.groups.r, 30);
	}
	
	var special = getHashSpecial(order_id, payment_id, refund_id);
	if((special%100)!==parseInt(reg_res.groups.s)) return null;
	return { order_id, payment_id, refund_id };
}

function mimeToAssetType(mime: string) : AssetType{
	if(mime.toLowerCase().trim()==='application/pdf'){
		return AssetType.PDF;
	}else if(mime.startsWith('image/')){
		return AssetType.IMAGE;
	}else{
		return null;
	}
}


export {
	dehashPaymentOrder,
	getPayoutTypeLocale,
	hashPaymentOrder,
	mimeToAssetType,
	TERMINAL_TYPES,
}